import React from 'react';
import { truncateLongString } from 'src/utils/formatter';
import { formatDate } from 'src/utils/helpers';
import { IDeliveryRequest } from 'src/view/screens/DeliveryManagementScreen/screens/DeliveryTrackingScreen/types/deliveryTracking';

interface IProps {
  deliveryRequest: IDeliveryRequest;
}

const DeliveryRequestInfoModalTopBar = ({ deliveryRequest }: IProps): JSX.Element => {
  return (
    <div className="d-flex flex-row">
      <div className="d-flex flex-column mr-6">
        <h3 className="family-bold text-size-10 letter-spacing-12 text-uppercase mb-2">Client order</h3>
        <p className="family-semibold text-size-16">{truncateLongString(deliveryRequest.booking_id)}</p>
      </div>
      <div className="d-flex flex-column mr-6">
        <h3 className="family-bold text-size-10 letter-spacing-12 text-uppercase mb-2">CREATED AT</h3>
        <p className="family-semibold text-size-16">{formatDate(deliveryRequest.created_at, {})}</p>
      </div>
      <div className="d-flex flex-column mr-6">
        <h3 className="family-bold text-size-10 letter-spacing-12 text-uppercase mb-2">payment type</h3>
        <p className="family-semibold text-size-16">{deliveryRequest.order.payment_type}</p>
      </div>
      <div className="d-flex flex-column mr-6">
        <h3 className="family-bold text-size-10 letter-spacing-12 text-uppercase mb-2">total</h3>
        {/* <p className="family-semibold text-size-16">{deliveryRequest.order.total}</p>*/}
      </div>
      <div className="d-flex flex-column mr-6">
        <h3 className="family-bold text-size-10 letter-spacing-12 text-uppercase mb-2">DUE TIME</h3>
        <p className="family-semibold text-size-16">{deliveryRequest.dsp_timeout}</p>
      </div>
      <div className="d-flex flex-column mr-6">
        <h3 className="family-bold text-size-10 letter-spacing-12 text-uppercase mb-2">Distance</h3>
        {/* need data from back */}
        {/* <p className="family-semibold text-size-16">0.5 km</p>*/}
      </div>
    </div>
  );
};

export default DeliveryRequestInfoModalTopBar;
